import React from "react";
import { Card, Col, Placeholder } from "react-bootstrap";


/**
 * PlaceholderCard
 * 
 * Displays animation while waiting for server to returns anlage data
 * 
 * used in everywhere where some type of AnlageCard is present.
 * 
 * @returns html placeholdercard
 */
const PlaceholderCard = () => {

    return (
        <Col xs="12" xl="8">
            <Card className="mt-3 shadow-lg">
                <Placeholder className="text-start" as={Card.Header} animation="glow">
                    <Placeholder xs={4} />
                </Placeholder>
                <Placeholder as={Card.Body} animation="glow" className="text-start">
                    <Placeholder xs={6} />
                    <Placeholder xs={8} />
                    <Placeholder xs={5} />
                    <br />
                </Placeholder>
            </Card>
        </Col>
    )
}

export default PlaceholderCard;